import React, { useEffect, useState } from 'react';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton';
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import ModalComponent from '../../../components/global/modal/ModalComponent.jsx';
import columns from '../../../columns/ibApproved/reject.js';
import { GetAllIbApi, GetAllIBByIdApi } from "../../../api/request/ibapproved.js";
import moment from "moment";
import Eye from '../../../assets/Eye.jsx';
import { Spin } from 'antd';

export default function IbReject({ searchText }) {

    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isReject, setIsReject] = useState(false);
    const [isLoadingIBDetails, setIsLoadingIBDetails] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [selectedIBId, setSelectedIBId] = useState('');
    const [iBDetails, setIBDetails] = useState({});
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    const getAllIB = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FilterText: "Declined",
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllIbApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            requestDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY hh:mm A") : null),
                            actionDate: (item?.actionDate ? moment(item?.actionDate).format("DD-MM-YYYY, hh:mm A") : null),
                            action: (<button type="button" onClick={() => { setSelectedIBId(item?.userId); setIsReject(true) }}><Eye /></button>),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllIB();
    }, [page, pageSize, searchText, sorter]);

    const getIBById = async () => {
        try {
            setIsLoadingIBDetails(true);
            const { data } = await GetAllIBByIdApi(selectedIBId);
            setIBDetails(data?.data);
            setIsLoadingIBDetails(false);
        } catch (error) {
            setIsLoadingIBDetails(false);
        }
    }

    useEffect(() => {
        if (selectedIBId) {
            getIBById();
        }
    }, [selectedIBId]);
    return (
        <>
            {/* Reject table */}
            <div className="my-6">
                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <TableWithSkeleton
                        columns={columns}
                        data={data}
                        loading={isLoading}
                        onChange={handleTableChange}
                        page={page}
                        pageSize={pageSize}
                        index={true}
                    />
                </div>
                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            {/* Reject Modal */}
            <ModalComponent isOpen={isReject} setIsOpen={setIsReject} title='IB Details' width={1300}>
                {
                    isLoadingIBDetails ? (
                        <div className="flex justify-center flex-col my-[5%]">
                            <Spin size="large" />
                            <p className="primary text-center mt-2">Loading...</p>
                        </div>
                    ) : (
                        <div className='p-5'>
                            <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                                <div>
                                    <p className='text-base font-normal '>First Name</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.firstName}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Last Name</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.lastName}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Mobile No.</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.phoneNo}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Email</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.email}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Request Time</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.createdDate ? moment(iBDetails?.createdDate).format('DD-MM-YYYY, hh:mm A') : '--'}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Decline Time</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.actionDate ? moment(iBDetails?.actionDate).format('DD-MM-YYYY, hh:mm A') : '--'}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Declined by </p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.actionBy}</p>
                                </div>
                                <div>
                                    <p className='text-base font-normal '>Comment</p>
                                    <p className='text-xl primary font-semibold  mt-2'>{iBDetails?.comment}</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </ModalComponent>
        </>
    )
}
